import React, { useState } from "react";
import { AI_LAYERS, LAYER_SCENARIOS } from "./data.js";

export default function LayersStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [picked, setPicked] = useState(null);

  const current = LAYER_SCENARIOS[index];
  const done = index >= LAYER_SCENARIOS.length;

  const choose = (layerId) => {
    if (picked) return;
    const correct = layerId === current.correct;
    if (correct) setCorrectCount((c) => c + 1);
    setPicked(layerId);
  };

  const advance = () => {
    setPicked(null);
    setIndex((i) => i + 1);
  };

  if (done) {
    return (
      <div className="animate-popIn text-center">
        <p className="label-pixel mb-2 text-gold">AI Layers Complete</p>
        <h2 className="pixel-heading mb-4 text-base text-mist">Three Layers, Mapped</h2>

        <div className="mx-auto mb-6 max-w-sm space-y-2 border-2 border-black bg-ink p-4 text-left text-sm">
          <div className="flex justify-between">
            <span className="text-mist/60">Right Layer</span>
            <span className="text-gold">
              {correctCount}/{LAYER_SCENARIOS.length}
            </span>
          </div>
        </div>

        <p className="mx-auto mb-6 max-w-sm text-xs text-mist/60">
          Infrastructure, Implementation, or Career Shielding — three completely different ways to
          stand in the same wave. None of them require picking which AI company "wins."
        </p>

        <button onClick={() => onComplete({ correctCount })} className="btn-magenta">
          RUN THE VENTURE ▶
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>THE AI LAYERS</span>
        <span>
          {index}/{LAYER_SCENARIOS.length}
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">Which layer of the AI wave is this actually?</p>

      <div
        key={current.id}
        className={`mb-5 border-2 bg-ink p-6 text-center transition-colors ${
          picked ? (picked === current.correct ? "border-lime shadow-glow-cyan" : "border-danger") : "border-black"
        }`}
      >
        <p className="text-sm leading-relaxed text-mist/80">{current.text}</p>
      </div>

      {!picked ? (
        <div className="space-y-2">
          {AI_LAYERS.map((layer) => (
            <button
              key={layer.id}
              onClick={() => choose(layer.id)}
              className="flex w-full items-center justify-between border-2 border-mist/30 px-4 py-3 text-left transition-colors hover:border-gold hover:text-gold"
            >
              <span className="font-display text-[9px] uppercase">{layer.label}</span>
              <span className="text-[11px] text-mist/50">{layer.subtitle}</span>
            </button>
          ))}
        </div>
      ) : (
        <div
          className={`animate-popIn border-2 p-4 text-center ${
            picked === current.correct ? "border-lime bg-lime/10 text-lime" : "border-danger bg-danger/10 text-danger"
          }`}
        >
          <p className="mb-1 font-display text-[9px] uppercase">
            {picked === current.correct
              ? "Right Layer"
              : `Not Quite — It Was ${AI_LAYERS.find((l) => l.id === current.correct)?.label}`}
          </p>
          <p className="mb-3 text-xs text-mist/80">{current.explain}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
